export default function Header() {
    return (
        <div className="pt-32 lg:flex items-center relative z-10 container mx-auto">
            <div className="w-full lg:w-1/2 h-full lg:pr-10 xl:pr-0">
                <img className="mx-auto rounded-3xl" src="https://res.cloudinary.com/cosmic-records/image/upload/v1635786720/cosmic%20records/port_image_chicago_iirrur.jpg" alt="" />
            </div>
            <div className="w-full lg:w-1/2 h-full">
                <p className="text-blue font-regular text-4xl md:text-7xl">Josh Nolan</p>
                <p className="text-gray-700 font-regular">COMBINING TECHNOLOGY AND DESIGN.</p>
                <div className="sm:flex items-center py-2">
                    <div className="flex items-center">
                    </div>
                </div>
            </div>
        </div>
    )
}












